import React from 'react';
import { string, func, bool } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { Info } from '@one-thd/sui-icons';

const LaundryContainerTitle = ({ text, onInfoClick, wrap }) => {
  const words = text.split(' ');
  return (
    <div
      data-testid="container-title"
      className={`sui-flex sui-items-center ${wrap ? 'sui-flex-wrap' : 'sui-flex-nowrap'} sui-whitespace-pre`}
    >
      {
        words.map((word, index) => (
          <Typography
            key={index}
            variant="body-xs"
            weight="bold"
            height="tight"
          >
            {`${word}${index === words.length - 1 ? '' : ' '}`}
          </Typography>
        ))
      }
      {/* eslint-disable-next-line max-len, tailwindcss/no-arbitrary-value */}
      <button type="button" className="[&_svg]:sui-block sui-ml-2" onClick={onInfoClick} aria-label="More information">
        <Info size="small" />
      </button>
    </div>
  );
};

LaundryContainerTitle.propTypes = {
  text: string,
  onInfoClick: func,
  wrap: bool
};

LaundryContainerTitle.defaultProps = {
  text: '',
  onInfoClick: () => {},
  wrap: false
};

export default LaundryContainerTitle;